var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 29.3333V5.33329C8 4.97329 8 4.59996 8.09333 4.23996C8.17494 3.8808 8.35564 3.55172 8.6149 3.2901C8.87416 3.02848 9.20159 2.84482 9.56 2.75996C9.94667 2.66663 11.64 2.66663 12 2.66663H21.3333C21.6933 2.66663 22.0667 2.66663 22.4267 2.75996C22.7858 2.84157 23.1149 3.02227 23.3765 3.28153C23.6381 3.54079 23.8218 3.86822 23.9067 4.22663C24 4.59996 24 4.97329 24 5.33329V29.3333H8Z",
    stroke: "#047857",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66654 18.6667V26.6667C2.66654 28.1333 3.86654 29.3333 5.33321 29.3333H7.99987V16H5.33321C4.97321 16 4.59987 16 4.23987 16.0933C3.87987 16.1867 3.54654 16.36 3.27987 16.6267C3.02654 16.88 2.85321 17.2133 2.75987 17.5733C2.68461 17.9327 2.65326 18.2998 2.66654 18.6667Z",
    stroke: "#047857",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.76 12.0934C27.4007 12.0181 27.0335 11.9868 26.6667 12H24V29.3334H26.6667C27.3739 29.3334 28.0522 29.0524 28.5523 28.5523C29.0524 28.0522 29.3333 27.3739 29.3333 26.6667V14.6667C29.3333 14.2934 29.3333 13.9334 29.24 13.5734C29.1467 13.2134 28.9733 12.88 28.7067 12.6134C28.4533 12.36 28.12 12.1867 27.76 12.0934Z",
    stroke: "#047857",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 8H18.6668",
    stroke: "#047857",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 13.3334H18.6668",
    stroke: "#047857",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 18.6666H18.6668",
    stroke: "#047857",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 24H18.6668",
    stroke: "#047857",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding2);
export default __webpack_public_path__ + "static/media/building-2.b3760904ba429598d4548146fa11e540.svg";
export { ForwardRef as ReactComponent };